module.exports = __webpack_public_path__ + "static/media/dummy-image.2d729cf8.png";